import { N500, N900 } from '@atlaskit/theme/colors';
import { fontFallback } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { type FunctionComponent } from 'react';

import { type App } from '../../types';

const valuePropositionStyles = css({
	display: 'flex',
	flexDirection: 'column',
	marginRight: token('space.300', '24px'),
});

const headerStyles = css({
	font: token('font.heading.xsmall', fontFallback.heading.xsmall),
	color: token('color.text', N900),
});

const bodyStyles = css({
	font: token('font.body', fontFallback.body.medium),
	marginTop: token('space.050', '4px'),
	color: token('color.text.subtle', N500),
});

export const ValueProposition: FunctionComponent<{ app: App }> = ({ app }) => {
	return (
		<div css={valuePropositionStyles}>
			<div role="presentation" css={headerStyles}>
				{app.header}
			</div>
			<p css={bodyStyles}>{app.description}</p>
		</div>
	);
};
